import React from 'react'

import Field from '@utilities/Field'
import FieldContainer from './FieldContainer'

class IntegerField extends Field {
  displayName = 'IntegerField'

  handleChange({ target }: any) {
    const { name } = this.props
    let value = target.value
    value = value.replace(/,/g, '')
    value = value.replace(/ /g, '')
    value = value.trim() === '0' ? 0 : parseInt(value, 10) || null
    this.props.onChange(name, value)
  }

  render() {
    const { autoComplete, field, name, info, icon, label, optional } = this.props
    let inputClassName = 'Input'

    // Add comma to integers (per thousand)
    const value2 = field.value !== null ? String(field.value).split('') : ''

    let val = ''
    const len = value2.length
    if (len > 0) {
      for (let i = 0; i < len; i++) {
        val = value2[len - 1 - i] + val
        if (i !== len - 1 && (i + 1) % 3 === 0) {
          val = ', ' + val
        }
      }
    }

    return (
      <FieldContainer field={field} info={info} icon={icon} label={label} optional={optional}>
        <input
          autoComplete={autoComplete}
          id={name}
          name={name}
          className={inputClassName}
          value={val || ''}
          placeholder={this.props.placeholder}
          onFocus={this.handleFocus}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
        />
      </FieldContainer>
    )
  }
}

export default IntegerField
